
import PropTypes from 'prop-types';

import { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';

import Iconify from 'src/components/Iconify';
import { NEGOCIO_ROW_LABEL_W } from './NegocioInfoRow';
import buscarCep from 'src/actions/chats/buscarCep';
import PhoneInput from 'react-phone-number-input'
import { formataNumeroCelular, maskCPF, maskDate } from 'src/utils/functions';
import v2_actionPesquisarContatos from 'src/actions/v2/contatos/v2_actionPesquisarContatos';
import v2_actionEditarContato from 'src/actions/v2/contatos/v2_actionEditarContato';
import ModalNovoContato from 'src/sections/@chats/chat/Modals/ModalNovoContato';
import { Input } from 'src/@/components/ui/input';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import { Button } from 'src/@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from "src/@/components/ui/popover";
import { X } from "lucide-react";


DrawerContatos.propTypes = {
    isCollapse: PropTypes.bool,
    onCollapse: PropTypes.func
};

const FieldInput = ({ label, isRequired, children, className = "" }) => (
    <div className={`flex items-center gap-3 ${className}`}>
        <div className={`flex items-center gap-1 ${NEGOCIO_ROW_LABEL_W}`}>
            <label className="text-[11px] font-semibold uppercase tracking-wider text-gray-500 dark:text-[#ABABAD]">
                {label}
            </label>
            {isRequired && (
                <span className="text-[9px] text-red-500 font-bold uppercase">*</span>
            )}
        </div>
        <div className="flex-1">{children}</div>
    </div>
);

const inputClasses = "h-9 bg-gray-50 dark:bg-[#1A1D21] border-gray-200 dark:border-[#383838] dark:text-[#D1D2D3] focus:border-[#7C3AED]/50 focus:ring-[#7C3AED]/20 text-xs font-medium rounded-lg hover:border-[#7C3AED]/30 transition-all";

const ItemSearchContacts = ({
    onOpenModalContact,
    onClear,
    contactId,
    onOpen,
    open,
    pesquisa,
    changePesquisa,
    listaContatos,
    onSelect
}) => {
    return (
        <div className="flex items-center gap-2">
            <Popover open={open} onOpenChange={onOpen}>
                <PopoverTrigger asChild>
                    <Button
                        variant="outline"
                        className="flex-1 justify-start text-left h-9 bg-gray-50 dark:bg-[#1A1D21] border-gray-200 dark:border-[#383838] dark:text-[#D1D2D3] hover:border-[#7C3AED]/30 rounded-lg text-xs font-medium transition-all"
                    >
                        <Iconify icon="mdi:account-search" width={16} className="text-gray-400 dark:text-[#ABABAD] mr-2 flex-shrink-0" />
                        {contactId
                            ? `${contactId.nome} - ${formataNumeroCelular(contactId.telefone)}`
                            : "Escolha um contato..."}
                    </Button>
                </PopoverTrigger>

                <PopoverContent className="w-[340px] p-0 dark:bg-[#222529] dark:border-[#383838]" align="start">
                    <div className="p-2 border-b border-gray-100 dark:border-[#383838]">
                        <div className="relative">
                            <Iconify icon="mdi:magnify" width={16} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 dark:text-[#ABABAD]" />
                            <input
                                type="text"
                                placeholder="Pesquise o contato..."
                                value={pesquisa}
                                onChange={(e) => changePesquisa(e.target.value)}
                                className="w-full pl-8 pr-3 py-2 text-xs font-medium rounded-lg bg-gray-50 dark:bg-[#1A1D21] border border-gray-200 dark:border-[#383838] dark:text-[#D1D2D3] dark:placeholder:text-[#565856] focus:border-[#7C3AED]/50 focus:ring-1 focus:ring-[#7C3AED]/20 outline-none transition-all"
                            />
                        </div>
                    </div>

                    <div className="max-h-60 overflow-y-auto">
                        {listaContatos.length > 0 ? (
                            listaContatos.map((option) => (
                                <div
                                    key={option._id}
                                    onClick={() => onSelect(option)}
                                    className="flex items-center gap-2.5 px-3 py-2.5 hover:bg-violet-50/30 dark:hover:bg-violet-500/5 cursor-pointer transition-colors border-b border-gray-50 dark:border-[#383838]/50 last:border-b-0"
                                >
                                    <div className="w-7 h-7 rounded-full bg-violet-100 dark:bg-violet-500/20 flex items-center justify-center flex-shrink-0">
                                        <Iconify icon="mdi:account" width={14} className="text-violet-600 dark:text-violet-400" />
                                    </div>
                                    <div className="min-w-0">
                                        <p className="text-xs font-semibold text-gray-900 dark:text-[#D1D2D3] truncate">{option.nome}</p>
                                        <p className="text-[10px] text-gray-400 dark:text-[#ABABAD]">{formataNumeroCelular(option.telefone)}</p>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="flex flex-col items-center justify-center py-8 px-4">
                                <div className="w-10 h-10 rounded-full bg-gray-100 dark:bg-[#383838] flex items-center justify-center mb-2">
                                    <Iconify icon="mdi:account-search-outline" width={20} className="text-gray-300 dark:text-[#565856]" />
                                </div>
                                <p className="text-xs font-medium text-gray-400 dark:text-[#ABABAD]">Nenhum contato encontrado</p>
                                <button
                                    onClick={onOpenModalContact}
                                    className="mt-3 flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-[#7C3AED] hover:bg-violet-50 dark:hover:bg-violet-500/10 rounded-lg transition-colors"
                                >
                                    <Iconify icon="mdi:plus" width={14} />
                                    Criar Contato
                                </button>
                            </div>
                        )}
                    </div>
                </PopoverContent>
            </Popover>

            {contactId ? (
                <Button
                    size="icon"
                    variant="outline"
                    onClick={onClear}
                    className="h-9 w-9 flex-shrink-0 border-gray-200 dark:border-[#383838] hover:border-red-300 hover:bg-red-50 dark:hover:bg-red-500/10 hover:text-red-500 transition-all rounded-lg"
                >
                    <X className="w-4 h-4" />
                </Button>
            ) : (
                <Button
                    onClick={onOpenModalContact}
                    size="icon"
                    className="h-9 w-9 flex-shrink-0 bg-[#7C3AED] hover:bg-[#6D28D9] text-white rounded-lg shadow-sm shadow-violet-500/20 transition-all hover:scale-105 active:scale-95"
                >
                    <Iconify icon="mdi:account-plus" width={16} />
                </Button>
            )}
        </div>
    )
}


export default function DrawerContatos({
    user,
    cliente,
    lead,
    onEditarContatoId,
    callbackCreateContact
}) {

    const { enqueueSnackbar } = useSnackbar();
    const [pesquisa, setPesquisa] = useState('');
    const [contactId, setContactId] = useState(lead?.contato);
    const [isChange, setIsChange] = useState(null);
    const [loadingEditarContato, setLoadingEditarContato] = useState(null);
    const [stateModalNovoContato, setStateModalNovoContato] = useState(null);
    const [open, setOpen] = useState(false);
    const [listaContatos, setListaContatos] = useState([]);

    const [contato, setContato] = useState({
        nome: lead?.contato?.nome,
        email: lead?.contato?.info?.email,
        whatsapp: lead?.contato?.telefone,
        dataNascimento: lead?.contato?.info?.dataNascimento,
        cpf: lead?.contato?.info?.cpf
    });
    const [endereco, setEndereco] = useState({
        cep: lead?.contato?.info?.endereco?.cep,
        rua: lead?.contato?.info?.endereco?.rua,
        numero: lead?.contato?.info?.endereco?.numero,
        bairro: lead?.contato?.info?.endereco?.bairro,
        cidade: lead?.contato?.info?.endereco?.cidade,
        estado: lead?.contato?.info?.endereco?.estado,
        complemento: lead?.contato?.info?.endereco?.complemento
    });

    async function pesquisarContatos(pesquisa) {
        try {
            const result = await v2_actionPesquisarContatos(cliente._id, pesquisa)
            setListaContatos(result.data.data)
        } catch (error) {
            console.log(error);
        }
    }

    async function editarContato() {
        setLoadingEditarContato(true);
        try {
            let data =
            {
                scope: {
                    nome: contato.nome,
                    telefone: contato.telefone,
                    info: {
                        email: contato.email,
                        cpf: contato.cpf,
                        dataNascimento: contato.dataNascimento,
                        endereco: {
                            cep: endereco.cep,
                            rua: endereco.rua,
                            bairro: endereco.bairro,
                            cidade: endereco.cidade,
                            estado: endereco.estado,
                            numero: endereco.numero,
                            complemento: endereco.complemento
                        }
                    }
                }
            }

            await v2_actionEditarContato(contactId._id, data)
            setLoadingEditarContato(false);
            setIsChange(false);
            enqueueSnackbar('Contato alterado com sucesso', { variant: 'success', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
        } catch (error) {
            setLoadingEditarContato(false);
            console.log(error);
        }
    }

    const handleOnBlurSearchCep = async (zipCode) => {
        try {
            const address = await buscarCep(zipCode)
            if (!address.erro) {
                setEndereco({
                    cep: address.cep,
                    rua: address.logradouro,
                    bairro: address.bairro,
                    cidade: address.localidade,
                    estado: address.uf,
                })
            }
        } catch (address) {

        }
    }

    useEffect(() => {
        setContato({
            nome: lead?.contato?.nome,
            email: lead?.contato?.info?.email,
            whatsapp: lead?.contato?.telefone,
            dataNascimento: lead?.contato?.info?.dataNascimento,
            cpf: lead?.contato?.info?.cpf
        });
        setEndereco({
            cep: lead?.contato?.info?.endereco?.cep,
            rua: lead?.contato?.info?.endereco?.rua,
            numero: lead?.contato?.info?.endereco?.numero,
            bairro: lead?.contato?.info?.endereco?.bairro,
            cidade: lead?.contato?.info?.endereco?.cidade,
            estado: lead?.contato?.info?.endereco?.estado,
            complemento: lead?.contato?.info?.endereco?.complemento
        });
        setContactId(lead?.contato);
    }, [lead, contactId]);

    return (
        <div className="space-y-4">

            <ModalNovoContato
                cliente={cliente}
                user={user}
                open={stateModalNovoContato}
                listaRespostas={[]}
                listaClientesCanais={[]}
                callbackAddContact={async (data) => {
                    await onEditarContatoId(data._id);
                    callbackCreateContact()
                }}
                onClose={() => {
                    setStateModalNovoContato(false);
                }}
            />

            {/* Seletor de Contato */}
            <div className="bg-white dark:bg-[#222529] rounded-xl border border-gray-100 dark:border-[#383838] p-4">
                <div className="flex items-center gap-2 mb-3">
                    <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-[#7C3AED]/10">
                        <Iconify icon="mdi:account-circle" width={16} className="text-[#7C3AED]" />
                    </div>
                    <span className="text-xs font-semibold text-gray-900 dark:text-[#D1D2D3]">Contato vinculado</span>
                </div>

                <ItemSearchContacts
                    contactId={contactId}
                    listaContatos={listaContatos}
                    onOpenModalContact={() => setStateModalNovoContato(true)}
                    onClear={() => {
                        setContactId(null);
                        onEditarContatoId(null);
                    }}
                    onOpen={() => setOpen(!open)}
                    open={open}
                    pesquisa={pesquisa}
                    changePesquisa={e => {
                        setPesquisa(e);
                        if (e.length > 3) {
                            pesquisarContatos(e);
                        } else {
                            setListaContatos([]);
                        }
                    }}
                    onSelect={(option) => {
                        setContactId(option);
                        onEditarContatoId(option._id);
                        setOpen(false);
                    }}
                />
            </div>

            {/* Formulário de dados do contato */}
            {contactId && (
                    <div className="space-y-4">

                        {/* Dados Pessoais */}
                        <div className="bg-white dark:bg-[#222529] rounded-xl border border-gray-100 dark:border-[#383838] p-4">
        
                            <div className="flex flex-col gap-3">
                                <FieldInput label="Nome" isRequired>
                                    <Input
                                        onChange={e => {
                                            setContato({ ...contato, nome: e.target.value })
                                            setIsChange(true);
                                        }}
                                        value={contato.nome}
                                        className={inputClasses}
                                        placeholder="Nome do contato"
                                    />
                                </FieldInput>

                                <FieldInput label="Telefone" isRequired>
                                    <PhoneInput
                                        international
                                        defaultCountry='BR'
                                        className="[&_input]:h-9 [&_input]:bg-gray-50 [&_input]:dark:bg-[#1A1D21] [&_input]:border [&_input]:border-gray-200 [&_input]:dark:border-[#383838] [&_input]:dark:text-[#D1D2D3] [&_input]:rounded-lg [&_input]:text-xs [&_input]:px-3 [&_input]:focus:border-[#7C3AED]/50 [&_input]:focus:ring-1 [&_input]:focus:ring-[#7C3AED]/20 [&_input]:outline-none [&_input]:transition-all"
                                        style={{ padding: 0, border: 'none' }}
                                        placeholder="Insira o número"
                                        value={contato.whatsapp}
                                        onChange={value => {
                                            setIsChange(true);
                                            setContato({ ...contato, whatsapp: value })
                                        }}
                                    />
                                </FieldInput>

                                <FieldInput label="Nascimento">
                                    <Input
                                        onChange={e => {
                                            setContato({ ...contato, dataNascimento: e.target.value });
                                            setIsChange(true);
                                        }}
                                        value={contato.dataNascimento && maskDate(contato.dataNascimento)}
                                        className={inputClasses}
                                        placeholder="DD/MM/AAAA"
                                    />
                                </FieldInput>

                                <FieldInput label="Email">
                                    <Input
                                        type="email"
                                        onChange={e => {
                                            setContato({ ...contato, email: e.target.value });
                                            setIsChange(true);
                                        }}
                                        value={contato.email}
                                        className={inputClasses}
                                        placeholder="email@exemplo.com"
                                    />
                                </FieldInput>

                                <FieldInput label="CPF">
                                    <Input
                                        onChange={e => {
                                            setContato({ ...contato, cpf: e.target.value });
                                            setIsChange(true);
                                        }}
                                        value={contato.cpf && maskCPF(contato.cpf)}
                                        className={inputClasses}
                                        placeholder="000.000.000-00"
                                    />
                                </FieldInput>
                            </div>

                            {/* border*/}
                            <div className='border my-4 border-slate-200' ></div>
                

                            <div className="flex flex-col gap-3">
                                <FieldInput label="CEP">
                                    <Input
                                        onChange={e => {
                                            setEndereco({ ...endereco, cep: e.target.value })
                                            setIsChange(true);
                                        }}
                                        onBlur={e => handleOnBlurSearchCep(e.target.value)}
                                        value={endereco.cep}
                                        className={inputClasses}
                                        placeholder="00000-000"
                                    />
                                </FieldInput>

                                <FieldInput label="Rua">
                                    <Input
                                        onChange={e => {
                                            setEndereco({ ...endereco, rua: e.target.value })
                                            setIsChange(true);
                                        }}
                                        value={endereco.rua}
                                        className={inputClasses}
                                        placeholder="Nome da rua"
                                    />
                                </FieldInput>

                                <FieldInput label="Número">
                                    <Input
                                        onChange={e => {
                                            setEndereco({ ...endereco, numero: e.target.value });
                                            setIsChange(true);
                                        }}
                                        value={endereco.numero}
                                        className={inputClasses}
                                        placeholder="Nº"
                                    />
                                </FieldInput>

                                <FieldInput label="Bairro">
                                    <Input
                                        onChange={e => {
                                            setEndereco({ ...endereco, bairro: e.target.value });
                                            setIsChange(true);
                                        }}
                                        value={endereco.bairro}
                                        className={inputClasses}
                                        placeholder="Bairro"
                                    />
                                </FieldInput>

                                <FieldInput label="Complemento">
                                    <Input
                                        onChange={e => {
                                            setEndereco({ ...endereco, complemento: e.target.value })
                                            setIsChange(true);
                                        }}
                                        value={endereco.complemento}
                                        className={inputClasses}
                                        placeholder="Apto, bloco..."
                                    />
                                </FieldInput>

                                <FieldInput label="Cidade">
                                    <Input
                                        onChange={e => {
                                            setEndereco({ ...endereco, cidade: e.target.value })
                                            setIsChange(true);
                                        }}
                                        value={endereco.cidade}
                                        className={inputClasses}
                                        placeholder="Cidade"
                                    />
                                </FieldInput>

                                <FieldInput label="Estado">
                                    <Input
                                        onChange={e => {
                                            setEndereco({ ...endereco, estado: e.target.value });
                                            setIsChange(true);
                                        }}
                                        value={endereco.estado}
                                        className={inputClasses}
                                        placeholder="UF"
                                    />
                                </FieldInput>
                            </div>
                        </div>

                        {/* Botão Salvar */}
                        {isChange && (
                            <div className="flex justify-end">
                                <ButtonLoading
                                    onClick={editarContato}
                                    loading={loadingEditarContato}
                                    className="h-9 px-5 bg-[#7C3AED] hover:bg-[#6D28D9] text-white text-xs font-semibold rounded-lg shadow-lg shadow-violet-500/20 transition-all hover:scale-105 active:scale-95"
                                >
                                    <Iconify icon="mdi:content-save" width={16} className="mr-1.5" />
                                    Salvar alterações
                                </ButtonLoading>
                            </div>
                        )}
                    </div>
            )}

            {/* Empty state quando não tem contato */}
            {!contactId && (
                <div className="flex flex-col items-center justify-center py-12 text-gray-400 dark:text-[#ABABAD]">
                    <div className="w-12 h-12 rounded-full bg-gray-100 dark:bg-[#383838] flex items-center justify-center mb-3">
                        <Iconify icon="mdi:account-off-outline" width={24} className="text-gray-300 dark:text-[#565856]" />
                    </div>
                    <p className="text-sm font-medium">Nenhum contato vinculado</p>
                    <p className="text-xs mt-1">Selecione ou crie um contato acima</p>
                </div>
            )}
        </div>
    );
}
